var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.voltage)?_c('Icon',{attrs:{"icon-name":"battery","width":"24","height":"24","fill":"#858585","title":_vm.tooltipText,"data-toggle":"tooltip","data-placement":"top"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }